import { render, staticRenderFns } from "./Transsion.vue?vue&type=template&id=4a4d5770&scoped=true&"
import script from "./Transsion.vue?vue&type=script&lang=js&"
export * from "./Transsion.vue?vue&type=script&lang=js&"
import style0 from "./Transsion.vue?vue&type=style&index=0&id=4a4d5770&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d5770",
  null
  
)

export default component.exports